import {AxiosResponse} from "axios";
import axios from "../api-instance";
import ENDPOINTS from "../consts/endpoints";
import {Lesson, Task, Course, TestResult} from "../common/course";
export type ICoursesrepository = {
    getCourses: Function;
    getCourseLessons: Function;
    getLesson: Function;
    getTask: Function;
    markTaskAsVisited: Function;
    getTasksByCourseId: Function;
    getTestById: Function;
    sendTestResults: Function;
    getTestLastSubmition: Function;
};
class CoursesRepository implements ICoursesrepository {
    private api = axios;
    private getData(response: AxiosResponse) {
        return response.data;
    }
    getCourses() {
        this.api.setHeaders();
        return this.api.get(ENDPOINTS.COURSES).then(this.getData);
    }
    getCourseLessons(courseId: Course['id']) {
        this.api.setHeaders();
        return this.api.get(`${ENDPOINTS.COURSES}/${courseId}/lessons`).then(this.getData);
    }
    getLesson(lessonId: Lesson['id']) {
        this.api.setHeaders();
        return this.api.get(`${ENDPOINTS.LESSONS}/${lessonId}/tasks`).then(this.getData);
    }
    getTask(taskId: string) {
       return [];
    }
    markTaskAsVisited({lessonId, taskId}: {lessonId: Lesson['id'], taskId: Task['id']}) {
        this.api.setHeaders();
        return this.api.post(`${ENDPOINTS.LESSONS}/${lessonId}/tasks/${taskId}/visit`);
    }
    getTasksByCourseId(courseId: Course['id']) {
        this.api.setHeaders();
        return this.api.get(`${ENDPOINTS.COURSES}/${courseId}/lessons/detailed`).then(this.getData);
    }
    getTestLastSubmition(testId: string) {
        this.api.setHeaders();
        return this.api.get(`${ENDPOINTS.TEST_CONTROLLERS}/${testId}/submissions/last`).then(this.getData);
    }
    getTestById(testId: string) {
        this.api.setHeaders();
        return this.api.post(`${ENDPOINTS.TEST_CONTROLLERS}/${testId}/submissions/renew`).then(this.getData);
    }
    sendTestResults({testId, answers}: TestResult) {
        this.api.setHeaders();
        return this.api.post(`${ENDPOINTS.TEST_CONTROLLERS}/${testId}/submissions`, answers).then(this.getData);
    }
}

export default CoursesRepository;